import React from 'react';
import { useLocation } from 'react-router-dom';
import { HeaderSkeletonWrapper, HeaderSkeletonStack, MenuIconSkeleton, LogoSkeleton, CartIconSkeleton, HeaderActionGroupSkeleton } from './style';

const HeaderSkeleton: React.FC = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <HeaderSkeletonWrapper position="static" isHome={isHome} className="app-header">
      <HeaderSkeletonStack direction="row" justifyContent="space-between" alignItems="center">
        {/* Menu icon skeleton (left) */}
        <MenuIconSkeleton variant="rectangular" width={40} height={40} />
        
        {/* Logo skeleton (center) */}
        <LogoSkeleton variant="rectangular" width={200} height={60} />
        
        {/* Account and cart icon skeletons (right) */}
        <HeaderActionGroupSkeleton>
          <CartIconSkeleton variant="rectangular" width={40} height={40} />
          <CartIconSkeleton variant="rectangular" width={40} height={40} />
        </HeaderActionGroupSkeleton>
      </HeaderSkeletonStack>
    </HeaderSkeletonWrapper>
  );
};

export default HeaderSkeleton;

